module.exports = __webpack_public_path__ + "img/Nick.c61a7e26.jpg";